<script lang="ts">
    import type { CardsetDto } from "@app/models/flashcardsApi.model";
    import { FAVORITE__Learn_with_flashcards } from "@app/services/i18n.messages";
    import { getMessage } from "@app/services/i18n.service";
    import { getCardsetCover } from "./cardsetUtils";
    import { getCardsApplicationUrl } from "@app/services/transferState-service";
    const FLASHCARDS_APP_URL = getCardsApplicationUrl();

    export let cardset: CardsetDto;

    export const getFlashcardsUrl = (cardsetId: string) =>
        `${FLASHCARDS_APP_URL}/flashcards/${cardsetId}-${Date.now()}`;

    const cover = getCardsetCover(cardset, 0);
</script>

<div class="pb-2 flex gap-2">
    <div
        class={`${cover.background} w-24 h-24 text-center rounded-md border border-slate-300`}
    >
        <img
            src={cover.coverUrl}
            class="w-full h-full object-contain rounded-md"
            alt="Cardset {cardset.title} cover"
        />
    </div>
    <div class="flex-1 flex flex-col justify-between">
        <h1 class="text-xl font-medium m-0">
            {cardset.title}
        </h1>
        <div class="clear-both" />

        <div class="flex">
            <a
                href={getFlashcardsUrl(cardset.id)}
                class="inline-flex items-center justify-center px-4 py-2 font-medium text-center focus:ring-4focus:outline-none rounded-lg text-white bg-blue-700 hover:bg-blue-800 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                >{getMessage(FAVORITE__Learn_with_flashcards)}</a
            >
        </div>
    </div>
</div>
